import {mapMutations, mapState} from "vuex";

export default {
    computed: {
        ...mapState(['errors']),
    },

    methods: {
        ...mapMutations([
            'setErrors',
            'clearErrors',
            'setErrorMessage',
        ]),
        updateErrors(errors) {
            this.setErrors(errors);
            window.setTimeout(() => {
                window.$.scrollTo('.form-error', 200, {offset: {top: -50}});
            }, 100);
            window.$('.form-error').siblings('.form-control, input, select, textarea').focus();
        },

        captureRequestErrors(error) {
            if (!error.response) {
                throw error;
            }

            if (!error.response.data.errors) {
                throw error;
            }
            var errorCount = Object.keys(error.response.data.errors).length;
            if (errorCount === 1) {
                this.setErrorMessage(`Please check the form for one error and try again`);
            } else {
                this.setErrorMessage(`Please check the form for ${errorCount} errors and try again`);
            }
            this.updateErrors(error.response.data.errors);
        },

        showErrorMessage(message) {
            this.setErrorMessage(message);
        },

        clearErrors () {
            this.setErrors({});
        },
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/UsesErrors.js